import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { CatalogDiscountInstanceDTOBase } from "./CatalogDiscountInstanceDTOBase";
import type { CatalogDiscountRef } from "./CatalogDiscountRef";
import type { CatalogDiscountStaff } from "./CatalogDiscountStaff";
import type { TrackedBase } from "./TrackedBase";

export class CatalogDiscountInstanceStaff implements CatalogDiscountInstanceDTOBase, TrackedBase {
  constructor(public readonly instanceId: number, public readonly discountType: string, public readonly nameOverride: string | null, public readonly startActive: Date | null, public readonly endActive: Date | null, public readonly universalCode: string | null, public readonly emailRegexp: string | null, public readonly amountCents: number | null, public readonly percent: string | null, public readonly isCaseSensitive: boolean | null, public readonly isGlobal: boolean | null, public readonly isSpecial: boolean | null, public readonly autoApply: boolean | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly discountId: CatalogDiscountStaff | null, public readonly discountIdTargetIds: CatalogDiscountRef) {
    this.cbiServiceContext = null;
    this.discountIdLoaded = this.discountId != null;
    this.discountIdCached = this.discountId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private discountIdLoaded: boolean;
  private discountIdCached: CatalogDiscountStaff | null;
  async discountIdLazy(): Promise<CatalogDiscountStaff> {
    if (!this.discountIdLoaded) {
      this.discountIdCached = await this.cbiServiceContext!.discountService().getCatalogDiscountStaff(this.discountIdTargetIds.discountId);
      this.discountIdLoaded = true;
    }
    return this.discountIdCached!;
  }
}
